import { createFileRoute } from '@tanstack/react-router'

import { PlatformAdminPage } from '../../../components/pages/backoffice/platform/platform-admin-page.tsx'
import { PermissionChecker } from '../../../components/templates/permission-checker.tsx'

export const Route = createFileRoute('/bo/admin/')({
  component: () => (
    <PermissionChecker requiredPermissions={['tech.configurations']}>
      <PlatformAdminPage />
    </PermissionChecker>
  ),
})
